export default __webpack_public_path__ + "static/media/analytics-marketing-team-3.82764a61.svg";